import { render, staticRenderFns } from "./HeaderCarouselEl.vue?vue&type=template&id=90bf84de&scoped=true&"
import script from "./HeaderCarouselEl.vue?vue&type=script&lang=ts&"
export * from "./HeaderCarouselEl.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderCarouselEl.vue?vue&type=style&index=0&lang=css&"
import style1 from "./HeaderCarouselEl.vue?vue&type=style&index=1&id=90bf84de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bf84de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VIcon,VRow,VSheet})
